export default __webpack_public_path__ + "static/media/911.4fd82786.png";